import { gql } from '@apollo/client';

const STOCK_TRANSACTION_FIELDS = gql`
  fragment StockTransactionFields on Transaction {
    id
    transactionType
    price
    quantity
    timestamp
    fees
    feeQuantity
    cost
    proceeds
    notes
    createdAt
    updatedAt
    hidden
    currency
    brokerBaseCurrency
    brokerFXRate
    brokerBaseAmount
    fxRateToUSD
    fxSource
    failedStatus
    failedAt
    locationId
    sourceLocationId
    destinationLocationId
  }
`;

export const ADD_STOCK_TRANSACTION = gql`
  ${STOCK_TRANSACTION_FIELDS}
  mutation AddStockTransaction(
    $portfolioId: ID!
    $stockId: ID!
    $transactionType: TransactionType!
    $price: String!
    $quantity: String!
    $timestamp: String!
    $fees: String
    $feeQuantity: String
    $notes: String
    $currency: String
    $brokerBaseCurrency: String
    $brokerFXRate: String
    $fxRateToUSD: String
    $locationId: ID
    $sourceLocationId: ID
    $destinationLocationId: ID
  ) {
    addStockTransaction(
      portfolioId: $portfolioId
      stockId: $stockId
      transactionType: $transactionType
      price: $price
      quantity: $quantity
      timestamp: $timestamp
      fees: $fees
      feeQuantity: $feeQuantity
      notes: $notes
      currency: $currency
      brokerBaseCurrency: $brokerBaseCurrency
      brokerFXRate: $brokerFXRate
      fxRateToUSD: $fxRateToUSD
      locationId: $locationId
      sourceLocationId: $sourceLocationId
      destinationLocationId: $destinationLocationId
    ) {
      success
      error
      stockId
      transaction {
        ...StockTransactionFields
      }
    }
  }
`;

export const EDIT_STOCK_TRANSACTION = gql`
  ${STOCK_TRANSACTION_FIELDS}
  mutation EditStockTransaction(
    $transactionId: ID!
    $portfolioId: ID!
    $transactionType: TransactionType
    $price: String
    $quantity: String
    $timestamp: String
    $fees: String
    $feeQuantity: String
    $notes: String
    $currency: String
    $brokerBaseCurrency: String
    $brokerFXRate: String
    $fxRateToUSD: String
    $locationId: ID
    $sourceLocationId: ID
    $destinationLocationId: ID
  ) {
    editStockTransaction(
      transactionId: $transactionId
      portfolioId: $portfolioId
      transactionType: $transactionType
      price: $price
      quantity: $quantity
      timestamp: $timestamp
      fees: $fees
      feeQuantity: $feeQuantity
      notes: $notes
      currency: $currency
      brokerBaseCurrency: $brokerBaseCurrency
      brokerFXRate: $brokerFXRate
      fxRateToUSD: $fxRateToUSD
      locationId: $locationId
      sourceLocationId: $sourceLocationId
      destinationLocationId: $destinationLocationId
    ) {
      success
      error
      stockId
      transaction {
        ...StockTransactionFields
      }
    }
  }
`;

export const DELETE_STOCK_TRANSACTION = gql`
  mutation DeleteStockTransaction($transactionId: ID!, $portfolioId: ID!) {
    deleteStockTransaction(transactionId: $transactionId, portfolioId: $portfolioId) {
      success
      error
      stockId
    }
  }
`;

export const SET_STOCK_TRANSACTION_HIDDEN = gql`
  mutation SetStockTransactionHidden(
    $transactionId: ID!
    $portfolioId: ID!
    $hidden: Boolean!
  ) {
    setStockTransactionHidden(
      transactionId: $transactionId
      portfolioId: $portfolioId
      hidden: $hidden
    ) {
      success
      error
      stockId
      transaction {
        id
        hidden
      }
    }
  }
`;
